import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

import { PageUrlKey } from '@/entities/page-url-key';
import { useFeatureFlag } from '@/hooks/use-feature-flag';
import { ContractsPage } from '@/modules/contracts/pages/contracts-page';
import { TrustCenterPage } from '@/modules/trust-center/pages/trust-center-page';
import { UserManagementPage } from '@/modules/user-management/pages/user-management-page';
import { AlertNotificationsPage } from '@/pages/account/alert-notifications';
import { PlatformStatusPage } from '@/platform-status/pages/platform-status';
import { UserPreferencesPage } from '@/user-preferences/pages/user-preferences';

import { Shell } from '../components/layout/shell';

export function RoutesAccount() {
  const { path } = useRouteMatch();
  const featureFlag = useFeatureFlag();

  return (
    <Switch>
      <Redirect
        exact
        from={path}
        to={`${path}/${PageUrlKey.ALERT_NOTIFICATIONS}`}
      />
      {featureFlag('contracts') ? (
        <Route
          exact
          path={`${path}/${PageUrlKey.CONTRACTS}`}
          component={function () {
            return (
              <Shell>
                <ContractsPage />
              </Shell>
            );
          }}
        />
      ) : null}
      {featureFlag('platformStatus') ? (
        <Route
          exact
          path={`${path}/${PageUrlKey.PLATFORM_STATUS}`}
          component={function () {
            return (
              <Shell>
                <PlatformStatusPage />
              </Shell>
            );
          }}
        />
      ) : null}
      {featureFlag('alertNotifications') ? (
        <Route
          exact
          path={[
            `${path}/${PageUrlKey.ALERT_NOTIFICATIONS}`,
            `${path}/${PageUrlKey.ALERT_NOTIFICATIONS}/new`,
            `${path}/${PageUrlKey.ALERT_NOTIFICATIONS}/edit`,
          ]}
          component={function () {
            return (
              <Shell>
                <AlertNotificationsPage />
              </Shell>
            );
          }}
        />
      ) : null}

      {featureFlag('trustCenter') ? (
        <Route
          exact
          path={`${path}/${PageUrlKey.TRUST_CENTER}`}
          component={function () {
            return (
              <Shell>
                <TrustCenterPage />
              </Shell>
            );
          }}
        />
      ) : null}

      {featureFlag('userManagement') ? (
        <Route
          exact
          path={`${path}/${PageUrlKey.USER_MANAGEMENT}`}
          component={function () {
            return (
              <Shell>
                <UserManagementPage />
              </Shell>
            );
          }}
        />
      ) : null}

      {featureFlag('userPreferences') ? (
        <Route
          exact
          path={`${path}/${PageUrlKey.USER_PREFERENCES}`}
          component={function () {
            return (
              <Shell>
                <UserPreferencesPage />
              </Shell>
            );
          }}
        />
      ) : null}

      <Redirect to="/" />
    </Switch>
  );
}
